"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColor = getColor;
exports.hsl2rgb = hsl2rgb;
exports.isDark = isDark;
exports.rgb2hex = rgb2hex;
exports.rgb2hsl = rgb2hsl;
var _color = _interopRequireDefault(require("color"));
var _colorString = _interopRequireDefault(require("color-string"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function isDark(color) {
  return color[0] * 0.299 + color[1] * 0.587 + color[2] * 0.114 > 186;
}
function normalizeHex(hex) {
  // Knock off the # and lowercase;
  return hex.substring(1).toLowerCase();
}
function getColor(cssColor) {
  var isValid = _colorString["default"].get(cssColor);
  var color = (0, _color["default"])(isValid ? cssColor : '#000');
  var _color$rgb$object = color.rgb().object(),
    r = _color$rgb$object.r,
    g = _color$rgb$object.g,
    b = _color$rgb$object.b,
    alpha = _color$rgb$object.alpha;
  var _color$hsl$object = color.hsl().object(),
    h = _color$hsl$object.h,
    s = _color$hsl$object.s,
    l = _color$hsl$object.l;
  var hex;

  // If a short hex came in, accept it as value.
  if (isValid && cssColor.length === 4) {
    hex = normalizeHex(cssColor);
  } else {
    hex = normalizeHex(color.hex());
  }
  return {
    h: Math.round(h),
    s: Math.round(s),
    l: Math.round(l),
    r: Math.round(r),
    g: Math.round(g),
    b: Math.round(b),
    a: isNaN(alpha) ? 1 : alpha,
    hex: hex
  };
}
function hsl2rgb(h, s, l) {
  var _Color$rgb$object = (0, _color["default"])({
      h: h,
      s: s,
      l: l
    }).rgb().object(),
    r = _Color$rgb$object.r,
    g = _Color$rgb$object.g,
    b = _Color$rgb$object.b;
  return {
    r: Math.round(r),
    g: Math.round(g),
    b: Math.round(b)
  };
}
function rgb2hex(r, g, b) {
  return normalizeHex((0, _color["default"])({
    r: r,
    g: g,
    b: b
  }).hex());
}
function rgb2hsl(r, g, b) {
  var _Color$hsl$object = (0, _color["default"])({
      r: r,
      g: g,
      b: b
    }).hsl().object(),
    h = _Color$hsl$object.h,
    s = _Color$hsl$object.s,
    l = _Color$hsl$object.l;
  return {
    h: Math.round(h),
    s: Math.round(s),
    l: Math.round(l)
  };
}